import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

const updateOperators = (apiToken, operators) => dispatch => {
  consolelog('[API CALL] updateOperators()', operators);
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_UPDATE_OPERATORS;
  const { cancelToken, cancelTokenKey } = createCancelToken('updateOperators');

  // リクエストパラメータ
  const params = {
    operators,
  };

  // axiosの設定
  const axiosConfig = {
    cancelToken,
  };

  return axios
    .post(url, params, axiosConfig)
    .then(res => {
      delCancelToken(cancelTokenKey);
      if (res.data && res.data.result) {
        dispatch({
          type: actionTypes.SUCCESS_API_UPDATE_OPERATORS,
          payload: res.data,
        });
      } else {
        dispatch({
          type: actionTypes.ERROR_API_UPDATE_OPERATORS_STATUS,
          payload: res.data,
        });
      }
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(
          thrown,
          dispatch,
          '',
          'ユーザー情報の更新に失敗しました。',
        );
      }
    });
};

export default updateOperators;
